'use client';
import Image from 'next/image';

export function DotCardIcon({ icon, alt }) {
    return (
        <div className="not-prose inline-block size-16 rounded-full bg-slate-950/5 p-2 md:size-20 md:p-3">
            <div className="relative size-full">
                <Image
                    src={icon}
                    alt={alt || ''}
                    fill={true}
                    className="object-cover"
                    sizes="64px"
                />
            </div>
        </div>
    );
}
